module.exports = __webpack_public_path__ + "img/sport_winter.d340635e.svg";